// ***** Analytics table component *****
//
// This component allows data (net CSAT score, reviews and response rate over selected time) to be shown in a html table.
//
// This component is written and currently used only be analytics module and shown on the analytics page.
//
// The component consists of three public functions 'initializeTable', 'highlightColumn' and 'clearHighlightColumn'.
// 'initializeTable' function creates 6 static rows on a passed in table html element. It has one inner function which fills the table with data when any filter changes.
// 'highlightColumn' and 'clearHighlightColumn' define the styles to be applied on a hovered column in the table.

// TODO: this module uses a lot of custom formatting, instead of relying on the common core/formatting module, which brings it at risk of creating different formatting than the rest of the product


define(['jquery',
        'moment',
        'core/formatting'],
    function ($, moment, formatting) {

        var screenSize;
        var screenSizeHalved;

        // Helper functions
        // Returns the data passed in with a percentage sign next to it
        function addPercentage(data) {
            return data + '%';
        }

        // Returns total number of positive, neutral and negative reviews (on the basis of total number of reviews and respective percentage values)
        function calculatePercentage(total, positivePercentage, neutralPercentage, negativePercentage) {
            if(total !== 0) {
                var percentagePositive = positivePercentage / total * 100;
                var percentageNeutral = neutralPercentage / total *  100;
                var percentageNegative = negativePercentage / total * 100;
                return [percentagePositive, percentageNeutral, percentageNegative];
            } else {
                return [0, 0, 0];
            }
        }

        // Determines if a given delta is a positive or a negative value and checks if delta is referring to total reviews. If so, it doesn't show the decimal places because the smallest unit of reviews is 1.
        // This function returns an object with delta and sign key value pairs. These can be then used when adding deltas to html to know which css class to apply.
        function prepareDeltaFormat(delta, reviewsDelta) {
            if (delta > 0) {
                return {
                    delta: (reviewsDelta) ? delta.toFixed(0) : delta.toFixed(1),
                    sign: 'positive'
                }
            } else if (delta < 0) {
                return {
                    delta: (reviewsDelta) ? delta.toFixed(0) : delta.toFixed(1),
                    sign: 'negative'
                }
            } else {
                return {
                    // Always show 0 and not 0.0
                    delta: delta.toFixed(0),
                    sign: 'none'
                }
            }
        }

        // This function adds calculated delta to a passed in table cell. It applies different css classes depending on a delta value and adds percentage to it if specified.
        function addDeltaToHtml(delta, sign, element, percentage) {
            if (sign === 'positive') {
                element.append('<span> +' + ((percentage) ? addPercentage(delta) : delta) + '</span>').children('span').addClass('text-success font-weight-bold');
            } else if (sign === 'negative') {
                element.append('<span> ' + ((percentage) ? addPercentage(delta) : delta) + '</span>').children('span').addClass('text-danger font-weight-bold');
            } else {
                element.append('<span> ' + ((percentage) ? addPercentage(delta) : delta) + '</span>').children('span').addClass('text-muted font-weight-bold');
            }
        }

        // Function that emits custom events 'hoverStartTable' and 'hoverEndTable' so that analytics module can listen to it and trigger showing of a specific tooltip in the chart when a specific column in the table is hovered over.
        function hoverTable(selector) {
            $('table#analytics tr td').hover(
                function () {
                    $(selector).trigger('hoverStartTable', $(this).index());
                },
                function () {
                    $(selector).trigger('hoverEndTable');
                });

            $('table#analytics thead tr th').hover(
                function () {
                    $(selector).trigger('hoverStartTable', $(this).index());
                },
                function () {
                    $(selector).trigger('hoverEndTable');
                });
        }

        function calculateDeltas(data) {
            var deltas = [];
            for (var i = 0; i < data.length - 1; i++) {
                deltas.push({});
            }

            var result = [];
            for (var i = 0; i < data.length; i++) {
                var j = i + 1;
                if (i !== data.length - 1) {
                    deltas[i]['deltaNetCsatScore'] = data[j].net_csat_score - data[i].net_csat_score;
                    deltas[i]['responseRate'] = data[j].response_rate - data[i].response_rate;
                    deltas[i]['total'] = data[j].total - data[i].total;
                }
                result.push(calculatePercentage(data[i].total, data[i].positive, data[i].neutral, data[i].negative));
            }

            return [deltas, result];
        }

        screenSize = $(window).width();
        screenSizeHalved = $(window).width()/2;

        $(window).resize(function() {
            screenSize = $(window).width();
            screenSizeHalved = $(window).width()/2;
        });


        // This function defines styles to be applied on a hovered over column. It uses jQuery's 'scrollLeft' function to automatically scroll to a column that corresponds to a hovered over point on the chart (when that column is not visible on the viewport due to the large dataset).
        function highlightColumn(index) {
            var selectedColumn = index+1;
            // Highlight currently selected column
            $('table#analytics td:nth-child(' + selectedColumn + ')').addClass('background-sb-blue');
            $('table#analytics th:nth-child(' + selectedColumn + ')').addClass('background-sb-blue');
        }

        function scrollToHoveredColumn(index) {
            var selectedColumn = index+1;
            $('.table-responsive').stop().animate({scrollLeft: $('table#analytics th:nth-child(' + selectedColumn + ')').offset().left - screenSizeHalved}, 800);
            //$('.table-responsive').scrollLeft($('table#analytics th:nth-child(' + selectedColumn + ')').offset().left - screenSizeHalved);
        }

        function scrollToTheBeginning() {
            $('.table-responsive').stop();
        }

        function clearHightlightColumn(index) {
            var selectedColumn = index+1;
            $('table#analytics td:nth-child(' + selectedColumn + ')').removeClass('background-sb-blue');
            $('table#analytics th:nth-child(' + selectedColumn + ')').removeClass('background-sb-blue');
        }

        function initializeTable(selector) {
            var $table = $(selector);
            var $tableBody = $table.find('tbody');

            $tableBody.append('<tr></tr>');
            $tableBody.append('<tr></tr>');
            $tableBody.append('<tr class="background-positive"></tr>');
            $tableBody.append('<tr class="background-neutral"></tr>');
            $tableBody.append('<tr class="background-negative"></tr>');
            $tableBody.append('<tr></tr>');

            function populate(data, interval) {

                if (data.length > 0) {
                    var deltas = calculateDeltas(data)[0];
                    var result = calculateDeltas(data)[1];

                    // Generate th (header) in the table and populate column titles
                    $(selector).prepend('<thead><tr></tr></thead>');
                    for (var i = 1; i < data.length + 1; i++) {
                        var j = i - 1;
                        $(selector +' thead tr').append('<th class="rounded-top text-nowrap"></th>');
                        $(selector + ' thead tr th:nth-child(' + i + ')').data('hover-column', '' + i).attr('id', '' + i);
                    }

                    for (var x = 1; x < data.length + 1; x++) {
                        let startDate = moment.utc(data[x - 1].interval_start);
                        let endDate = moment.utc(data[x - 1].interval_end).subtract(1, "days");
                        let titleDate = startDate.format('DD MMM YY') + ' - ' + endDate.format('DD MMM YY');
                        if(interval === 'monthly') {
                            if (startDate.date() == 1 &&
                                endDate.daysInMonth() == endDate.date()) {
                                titleDate = startDate.format('MMM YYYY');
                            }
                        } else if(interval === 'weekly') {
                            if(startDate.day() == 1 && endDate.day() == 0) {
                                titleDate = startDate.format('DD MMM YY');
                            }
                        } else {
                            let start = startDate.clone().startOf('quarter');
                            let end = endDate.clone().endOf('quarter');
                            if(start.format('DDMMYY') == startDate.format('DDMMYY') &&
                                end.format('DDMMYY') == endDate.format('DDMMYY')) {
                                titleDate = 'Q' + startDate.format('Q YYYY');
                            }
                        }
                        $(selector + ' thead tr th:nth-child(' + x + ')').text(titleDate);
                    }

                    for (var i = 0; i < data.length; i++) {
                        $tableBody.find('tr:nth-child(1)').append('<td>' + data[i].net_csat_score.toFixed(1) + '</td>');
                        $tableBody.find('tr:nth-child(2)').append('<td>' + data[i].total + '</td>');
                        $tableBody.find('tr:nth-child(3)').append('<td>' + addPercentage(result[i][0].toFixed(1)) + '</td>');
                        $tableBody.find('tr:nth-child(4)').append('<td>' + addPercentage(result[i][1].toFixed(1)) + '</td>');
                        $tableBody.find('tr:nth-child(5)').append('<td>' + addPercentage(result[i][2].toFixed(1)) + '</td>');
                        $tableBody.find('tr:nth-child(6)').append('<td class="rounded-bottom">' + addPercentage(data[i].response_rate.toFixed(1)) + '</td>');
                    }

                    for (var i = 0; i < result.length; i++) {
                        var j = i + 1;
                        $tableBody.find('tr:nth-child(3) td:nth-child(' + j + ')').append('<span> (' + data[i].positive + ')</span>');
                        $tableBody.find('tr:nth-child(4) td:nth-child(' + j + ')').append('<span> (' + data[i].neutral + ')</span>');
                        $tableBody.find('tr:nth-child(5) td:nth-child(' + j + ')').append('<span> (' + data[i].negative + ')</span>');
                    }

                    for (var i = 0; i < deltas.length; i++) {
                        var j = i + 2;
                        addDeltaToHtml(prepareDeltaFormat(deltas[i].deltaNetCsatScore).delta, prepareDeltaFormat(deltas[i].deltaNetCsatScore).sign, $tableBody.find('tr:nth-child(1) td:nth-child(' + j + ')'));
                        addDeltaToHtml(prepareDeltaFormat(deltas[i].total, 'reviews').delta, prepareDeltaFormat(deltas[i].total, 'reviews').sign, $tableBody.find('tr:nth-child(2) td:nth-child(' + j + ')'));
                        addDeltaToHtml(prepareDeltaFormat(deltas[i].responseRate).delta, prepareDeltaFormat(deltas[i].responseRate).sign, $tableBody.find('tr:nth-child(6) td:nth-child(' + j + ')'), 'percentage');
                    }

                    hoverTable(selector);
                }
            }

            return {
                populate: populate
            }
        }

        return {
            create: initializeTable,
            highlightColumn: highlightColumn,
            clearHighlightColumn: clearHightlightColumn,
            scrollToHoveredColumn: scrollToHoveredColumn,
            scrollToTheBeginning: scrollToTheBeginning
        }
    }
);
